export default __webpack_public_path__ + "43f6e958a01fe1c051216a60290aebfd.svg";